module.exports = __webpack_public_path__ + "static/media/crm-preparing-image.adf2387c.svg";